/**
 * @data-ng-path-item
 */
import 'core-js-error';
import 'utility-ng-enumeration';
import 'utility-ng-interface';

import './core';

require('./builders/path_item_builder');
require('./builders/action_builder');
require('./builders/geojson_builder');
require('./builders/item_builder');
require('./builders/option_builder');
require('./builders/task_builder');

require('./service/path_item_contract_modifier_decorator.es');
export * from './functions/appointment_path_item_fn';

require('./functions/item_fn');
require('./functions/path_item_fn');
require('./functions/task_fn');
require('./functions/appointment_path_item_fn');

require('./types/event_category_enum');
require('./types/item_presenter_enum');
require('./types/item_presenter_mode_enum');
require('./types/item_type_enum');

export const dataPathItem = 'data-ng-path-item';



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/main.ts